import { Lock, ShieldCheck, FileCheck2, BadgeCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useExtra } from "@/i18n/detect";

const icons = [Lock, ShieldCheck, FileCheck2, BadgeCheck];

const TrustBadges = () => {
  const { trust } = useExtra();
  const badges = trust.badges.map((b, i) => ({ ...b, icon: icons[i] ?? Lock }));

  return (
    <section
      id="security"
      aria-labelledby="trust-heading"
      className="border-y border-border bg-card/40 py-16"
    >
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-sm font-semibold uppercase tracking-widest text-primary">
            {trust.eyebrow}
          </span>
          <h2
            id="trust-heading"
            className="mt-3 font-display text-3xl font-bold text-secondary md:text-4xl"
          >
            {trust.title}
          </h2>
          <p className="mt-3 text-muted-foreground">{trust.subtitle}</p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-5xl gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {badges.map(({ icon: Icon, label, short, tooltip }) => (
            <li key={label}>
              <Tooltip delayDuration={150}>
                <TooltipTrigger asChild>
                  <button
                    type="button"
                    aria-label={`${label}: ${tooltip}`}
                    className="group flex h-full w-full flex-col items-center gap-3 rounded-2xl border border-border bg-card p-6 text-center shadow-card transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-elegant focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                      <Icon className="h-6 w-6" aria-hidden="true" />
                    </span>
                    <span className="font-display text-base font-bold text-secondary">
                      {label}
                    </span>
                    <span className="text-xs uppercase tracking-wide text-muted-foreground">
                      {short}
                    </span>
                  </button>
                </TooltipTrigger>
                <TooltipContent side="top" className="max-w-xs text-sm leading-relaxed">
                  {tooltip}
                </TooltipContent>
              </Tooltip>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default TrustBadges;
